"use client";

import Link from "next/link";
import Script from "next/script";
import { useEffect, useState } from "react";

const BANNER_DISMISSED_KEY = "storly-cookie-notice-dismissed";
const GA_MEASUREMENT_ID = "G-BLETEGZ44N";
const CLARITY_PROJECT_ID = "vjva4kd5bm";

export default function AnalyticsConsent() {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    setDismissed(!!window.localStorage.getItem(BANNER_DISMISSED_KEY));
  }, []);

  const dismiss = () => {
    window.localStorage.setItem(BANNER_DISMISSED_KEY, "1");
    setDismissed(true);
  };

  return (
    <>
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
      />
      <Script
        id="google-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${GA_MEASUREMENT_ID}');
          `,
        }}
      />
      <Script
        id="microsoft-clarity"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window,document,"clarity","script","${CLARITY_PROJECT_ID}");
          `,
        }}
      />

      {!dismissed && (
        <div className="fixed inset-x-4 bottom-4 z-50 mx-auto rounded border border-gray-200 bg-white/95 p-4 shadow-xl backdrop-blur-md sm:inset-x-6 sm:bottom-6">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <p className="text-xs leading-relaxed text-gray-600 max-w-2xl">
              We use cookies to understand site usage and improve Storly. See our{" "}
              <Link href="/privacy" className="font-semibold text-purple-600 hover:underline">
                Privacy Policy
              </Link>
              .
            </p>
            <button
              type="button"
              onClick={dismiss}
              className="min-h-11 shrink-0 rounded bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-3 text-sm font-bold text-white shadow-lg transition-opacity hover:opacity-90"
            >
              Got it
            </button>
          </div>
        </div>
      )}
    </>
  );
}
